jQuery(function ($) {
  var cartMotivator = {
    view: {
      progressBar: function () {
        console.log("cart motivator init");
      },

      processCartUpdates: function (data) {
         console.log(data)

        let totalPrice = data.original_total_price / 100;
        let cmDom = $(document).find('.ast-cart-motivator');
        let loadingBar = cmDom.find('.bar-loading');
        let tierLabel = '';
        let tierSpendPrice = 0;
        let tier3TotalPrice = cmDom.find('.cm-tier-3').length > 0 ? cmDom.find('.cm-tier-3').attr('data-total') : 0;
        console.log(tier3TotalPrice)
        console.log(cmDom.find('.cm-tier-3').length)

        cmDom.find('.cm-c-check').css('background-color', '#fff');

        if(totalPrice > 0 && totalPrice < parseFloat(cmDom.find('.cm-tier-1').attr('data-total'))) {
            loadingBar.css('width', '7%');
            tierLabel = cmDom.find('.cm-tier-1').attr('data-label');
            tierSpendPrice = parseFloat(cmDom.find('.cm-tier-1').attr('data-total')) - totalPrice;

            if(cmDom.find('.cm-tier-3').length == 0) {
              loadingBar.css('width', '15%');
            }

        } else if(totalPrice > parseFloat(cmDom.find('.cm-tier-1').attr('data-total')) && totalPrice < parseFloat(cmDom.find('.cm-tier-2').attr('data-total'))) {
            loadingBar.css('width', '33%');
            cmDom.find('.cm-tier-1 .cm-c-check').css('background-color', '#ffcfbe');
            tierLabel = cmDom.find('.cm-tier-2').attr('data-label');
            tierSpendPrice = parseFloat(cmDom.find('.cm-tier-2').attr('data-total')) - totalPrice;

            if(cmDom.find('.cm-tier-3').length == 0) {
              loadingBar.css('width', '55%');
            }

        } else if((totalPrice > parseFloat(cmDom.find('.cm-tier-2').attr('data-total')) && totalPrice < parseFloat(tier3TotalPrice)) || (totalPrice >= parseFloat(cmDom.find('.cm-tier-2').attr('data-total')) && tier3TotalPrice == 0)) {
            loadingBar.css('width', '72%');
            cmDom.find('.cm-tier-1 .cm-c-check').css('background-color', '#ffcfbe');
            cmDom.find('.cm-tier-2 .cm-c-check').css('background-color', '#ffcfbe');
            tierLabel = cmDom.find('.cm-tier-3').attr('data-label');
            tierSpendPrice = parseFloat(cmDom.find('.cm-tier-3').attr('data-total')) - totalPrice;

            if(cmDom.find('.cm-tier-3').length == 0) {
              loadingBar.css('width', '100%');
            }

        } else if(totalPrice >= parseFloat(cmDom.find('.cm-tier-3').attr('data-total'))) {
            loadingBar.css('width', '100%');
            cmDom.find('.cm-c-check').css('background-color', '#ffcfbe');
            cmDom.find('.cm-message').text('Congratulations, you get ' + cmDom.find('.cm-tier-3').attr('data-label') + '!')
        }
        
        if(totalPrice == 0) {
            loadingBar.css('width', '0%');
        }

        if(totalPrice < parseFloat(cmDom.find('.cm-tier-3').attr('data-total'))) {
            cmDom.find('.cm-message').text('Spend $' + tierSpendPrice.toFixed(2) + ' extra to get ' + tierLabel + '!');
        }
        
      },

      listenToCartUpdates: function () {
        // Listeners for product added and cart updates
        ["cart:updated", "ajaxProduct:added"].forEach((evt) =>
          document.addEventListener(evt, cartMotivator.view.getCartData, false)
        );
      },

      getCartData: function () {
        fetch(
          window.theme.routes.cart ? window.theme.routes.cart : "/cart.js",
          {
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          }
        )
          .then((response) => response.json())
          .then(cartMotivator.view.processCartUpdates);
      },

      init: function () {
        this.listenToCartUpdates();
        this.progressBar();
      },
    },
  };

  $(document).ready(function () {
    cartMotivator.view.init();
  });
});
